
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sdk_api",
      function () {
        return require("private-next-pages/sdk_api/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sdk_api"])
      });
    }
  